import axios from 'axios'
import memoize from 'lodash/memoize'

export default class QuovoAPI {
  constructor (token) {
    this.client = axios.create({
      headers: {
        authorization: `Bearer ${token}`
      }
    })

    this.getBrokerages = memoize(this.getBrokerages.bind(this))
    this.getBrokerage = memoize(this.getBrokerage.bind(this))
    this.ensureUser = memoize(this.ensureUser.bind(this))
  }

  async ensureUser () {
    try {
      return this.client.post('/quovo/ensureuser').then(r => r.data)
    } catch (err) {
      this.ensureUser.cache.clear()
      throw err
    }
  }

  async getBrokerages () {
    try {
      const { data } = await this.client.get('/quovo/brokerages')
      return data.brokerages
    } catch (err) {
      this.getBrokerages.cache.clear()
      throw err
    }
  }

  async getBrokerage (id) {
    try {
      const { data } = await this.client.get(`/quovo/brokerages/${id}`)
      return data.brokerage
    } catch (err) {
      this.getBrokerage.cache.clear()
      throw err
    }
  }

  async getSyncProgress (accountId) {
    await this.ensureUser()
    return this.client.get('/quovo/sync', { params: { account: accountId } }).then(r => r.data)
  }

  async getAccount (id) {
    await this.ensureUser()
    return this.client.get(`/quovo/accounts/${id}`).then(resp => resp.data)
  }

  async getAccounts () {
    const user = await this.ensureUser()
    return this.client.get(`/quovo/users/${user.id}/accounts`).then(resp => resp.data)
  }

  async sync (accountId) {
    await this.ensureUser()
    return this.client.post('/quovo/sync', { account: accountId }).then(r => r.data)
  }

  async deleteAccount (accountId) {
    await this.ensureUser()
    return this.client.delete(`/quovo/accounts/${accountId}`).then(resp => resp.data)
  }

  async createAccount (brokerageId, username, password) {
    const user = await this.ensureUser()

    return this.client.post('/quovo/accounts', {
      user: user.id,
      brokerage: brokerageId,
      username,
      password
    }).then(r => r.data)
  }

  async updateAccount (id, username, password) {
    await this.ensureUser()
    return this.client.put(`/quovo/accounts/${id}`, { username, password }).then(r => r.data)
  }

  async getChallenges (accountId) {
    await this.ensureUser()
    return this.client.get(`/quovo/accounts/${accountId}/challenges`).then(r => r.data)
  }

  async answerChallenge ({ challengeId, answer, question }) {
    await this.ensureUser()
    return this.client.put(
      `/quovo/challenges/${challengeId}`,
      { question, answer }
    ).then(r => r.data)
  }

  /**
   * Use this to create an instance from a token.
   * Ensures that cacheable things are cached.
   */
  static create (token) {
    return _create(token)
  }
}

const _create = memoize(function createQuovoAPI (token) {
  return new QuovoAPI(token)
})



// WEBPACK FOOTER //
// ./src/client/misc/QuovoAPI.js